import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetConsumable(id: string | undefined) {
  return useQuery(queries.products.getConsumableById(id || ''))
}
